module.exports = __webpack_public_path__ + "static/img/lijunfeng.ca7877e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/touxiang/lijunfeng.png
// module id = kDYX
// module chunks = 0